// Exact service hosts only. No suffix matching, UTM inference or search-engine inference.
export const AI_REFERRAL_HOSTS = Object.freeze({
  "chatgpt.com": "CHATGPT", "chat.openai.com": "CHATGPT",
  "www.perplexity.ai": "PERPLEXITY", "perplexity.ai": "PERPLEXITY",
  "claude.ai": "CLAUDE", "copilot.microsoft.com": "COPILOT", "gemini.google.com": "GEMINI"
});
export function classifyAiReferrer(value) {
  if (typeof value !== "string" || value.length > 2048) return null;
  try {
    const url = new URL(value);
    if (url.protocol !== "https:" || url.username || url.password || url.port) return null;
    return Object.hasOwn(AI_REFERRAL_HOSTS, url.hostname) ? AI_REFERRAL_HOSTS[url.hostname] : null;
  } catch { return null; }
}
export function referralDateRange(from, to, now = new Date()) {
  const day = new Date(now.toISOString().slice(0, 10));
  const earliest = new Date(day.getTime() - 89 * 86400000);
  const parse = value => /^\d{4}-\d{2}-\d{2}$/.test(value || "") && Number.isFinite(Date.parse(value)) && new Date(value).toISOString().slice(0,10) === value ? new Date(value) : null;
  const start = from ? parse(from) : new Date(day.getTime() - 29 * 86400000);
  const end = to ? parse(to) : day;
  if (!start || !end || start < earliest || end > day || start > end) throw new Error("Choose valid dates within the last 90 days (UTC).");
  return { start, end };
}
